import { render } from "./media_upload.vue?vue&type=template&id=8e180d3a"
import script from "./media_upload.js?vue&type=script&lang=js"
export * from "./media_upload.js?vue&type=script&lang=js"

import "./media_upload.vue?vue&type=style&index=0&id=8e180d3a&lang=scss"

import exportComponent from "M:\\Viridian Patriots\\Server\\pleroma-fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__